/* VD Notify Me — restyle the Notify Me! (Hengam/restock) modal to the VD design
   system + wire the sold-out triggers to it.

   What it does:
   1. Hides the app's own injected trigger buttons (.restock-alerts-notify-button,
      .nm-portal) so the native SOLD OUT visuals stay. Buttons stay in the DOM
      (off-screen) so we can proxy-click them.
   2. PDP: clicking a sold-out SIZE, or the whole-item SOLD OUT add button, opens
      the app modal with that variant pre-selected (bridge = set input[name=id] +
      dispatch change so the app injects its variant-level trigger, then click it).
   3. Restyles the app modal (.restock-alerts-modal-*) to VD DS and swaps its copy
      to match the approved Figma (title/subcopy/button/fine print).

   Notify Me! selectors (verified on live 2026-07-03):
   .restock-alerts-modal-wrapper.modalWrapperStyle  (scrim)
   .restock-alerts-modal-box.modalBoxStyle          (card)
   .restock-alerts-form-title.formTitleStyle        ("Contact via:")
   .restock-alerts-email-input.inputStyle / .restock-alerts-email-label
   .restock-alerts-sms-input / .restock-alerts-country-select / .restock-alerts-sms-label
   .restock-alerts-variant-select.selectBoxStyle    (size)
   .restock-alerts-submit-button.notifyButtonStyle  ("Notify Me When Available")
   .restock-alerts-notify-button                    (the trigger we proxy-click)
*/
(function () {
  'use strict';

  /* ---------- 1. CSS: hide app triggers + restyle modal to VD DS ---------- */
  function injectCSS() {
    if (document.getElementById('vd-notify-css')) return;
    var css = [
      /* hide app's own trigger buttons — keep in DOM (off-screen) for proxy-click */
      '.restock-alerts-notify-button,.nm-portal{position:absolute!important;left:-9999px!important;top:0!important;width:1px!important;height:1px!important;overflow:hidden!important;opacity:0!important;}',

      /* modal → VD DS */
      '.restock-alerts-modal-wrapper.modalWrapperStyle{background:rgba(22,22,22,.55)!important;}',
      '.restock-alerts-modal-box.modalBoxStyle{background:#fff!important;border-radius:0!important;box-shadow:0 24px 60px rgba(0,0,0,.28)!important;max-width:452px!important;width:calc(100vw - 32px)!important;padding:32px 36px!important;font-family:var(--vd-font-body,Archivo),Arial,sans-serif!important;}',
      '.restock-alerts-form{display:flex!important;flex-direction:column!important;gap:20px!important;}',
      /* title + subcopy via pseudo-elements (React owns the text node — never mutate it) */
      '.restock-alerts-form-title.formTitleStyle{font-size:0!important;line-height:0!important;margin:0!important;}',
      '.restock-alerts-form-title.formTitleStyle::before{content:"NOTIFY ME";display:block;font-family:var(--vd-font-display,"Big Shoulders Display"),sans-serif;font-weight:800;text-transform:uppercase;font-size:30px;line-height:1;letter-spacing:.01em;color:#161616;}',
      ".restock-alerts-form-title.formTitleStyle::after{content:\"Drop your email and we'll tell you the moment this size is back in stock.\";display:block;font-family:var(--vd-font-body,Archivo),sans-serif;font-weight:400;font-size:13px;line-height:1.4;color:#6a6a6a;margin-top:10px;}",
      '.channelWrapperStyle{display:flex!important;flex-direction:column!important;gap:8px!important;margin:0!important;}',
      '.restock-alerts-email-label.fieldLabelStyle,.restock-alerts-sms-label.fieldLabelStyle{font-family:var(--vd-font-mono,"Space Mono"),monospace!important;text-transform:uppercase!important;letter-spacing:.06em!important;font-size:11px!important;color:#8a8a8a!important;}',
      '.inputStyle,.selectBoxStyle{border:1px solid #e0e0e0!important;border-radius:0!important;background:#fff!important;height:48px!important;padding:0 14px!important;font-family:var(--vd-font-body,Archivo),sans-serif!important;font-size:14px!important;color:#161616!important;box-shadow:none!important;}',
      '.inputStyle::placeholder{color:#8a8a8a!important;}',
      '.restock-alerts-submit-button.notifyButtonStyle{background:#161616!important;color:transparent!important;border:0!important;border-radius:0!important;height:54px!important;font-size:0!important;box-shadow:none!important;}',
      ".restock-alerts-submit-button.notifyButtonStyle::before{content:\"NOTIFY ME WHEN IT'S BACK\";font-family:var(--vd-font-display,\"Big Shoulders Display\"),sans-serif;font-weight:800;text-transform:uppercase;letter-spacing:.04em;font-size:16px;color:#fff;}",
      '.restock-alerts-submit-button.notifyButtonStyle:hover{opacity:.9!important;}',
      '.restock-alerts-form::after{content:"One email the moment it restocks. Unsubscribe anytime.";display:block;font-family:var(--vd-font-body,Archivo),sans-serif;font-size:10px;line-height:1.4;color:#8a8a8a;text-align:center;margin-top:6px;}',
      '.modalCloseButtonWrapper svg{color:#161616!important;stroke:#161616!important;}',

      /* PDP sold-out size → clickable (was not-allowed) */
      '.vd-pdp__size.is-soldout{cursor:pointer!important;opacity:.55!important;text-decoration:line-through!important;}',
      '.vd-pdp__size.is-soldout:hover{opacity:1!important;border-color:#161616!important;}',
      /* PDP SOLD OUT add button → clickable notify affordance */
      '.vd-pdp__add[data-vd-notify]{opacity:1!important;cursor:pointer!important;}',
      '.vd-pdp__add[data-vd-notify]:hover{background:#161616!important;color:#fff!important;}',
      /* PLP card sold-out size → clickable (→ opens notify on the PDP) */
      '.vd-card__size.is-soldout{opacity:.55;text-decoration:line-through;cursor:pointer;}',
      '.vd-card__size.is-soldout:hover{opacity:1;border-color:#161616;}',
      /* PLP whole-item SOLD OUT tag → clickable (→ opens notify on the PDP) */
      '.vd-card__soldtag[data-vd-soldcard]{cursor:pointer;}',
      '.vd-card__soldtag[data-vd-soldcard]:hover{opacity:.85;}',
      /* (2026-08-21) overlay is NO LONGER hidden on sold-out cards — it hosts the
         NOTIFY ME button (vd-card.css swaps add/sizebox for it via .is-soldout) */
      '.vd-notify-loading,.vd-notify-loading *{cursor:progress!important;}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'vd-notify-css';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* Modal copy (title / subcopy / button label / fine print) is swapped entirely
     via CSS pseudo-elements in injectCSS() — the app is React-based, so mutating
     its text nodes directly gets reconciled away / duplicated. */

  /* ---------- 2. PDP bridge ---------- */
  function initPDP() {
    var sec = document.querySelector('[data-pdp]');
    if (!sec) return;
    var form = document.getElementById('vd-pdp-form') || sec.querySelector('.vd-pdp__form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    var addBtn = form.querySelector('[data-pdp-add]');
    var variants = [];
    try { variants = JSON.parse(sec.querySelector('[data-pdp-variants]').textContent); } catch (e) {}
    var pdpUserPicked = false; // true once the shopper clicks a size / the add button — prewarm must not fight them

    function appBtn() { return form.querySelector('.restock-alerts-notify-button'); }
    function clickApp() { var b = appBtn(); if (b) { b.click(); return true; } return false; }

    // The app locks its modal's size dropdown to the FIRST sold-out variant it
    // ever processed and ignores later input[name=id] changes — so we set that
    // dropdown directly to the clicked variant after the modal opens.
    function setModalSize(want) {
      if (!want) return;
      var t0 = Date.now(), asserts = 0;
      (function sync() {
        var sel = document.querySelector('.restock-alerts-modal-box .restock-alerts-variant-select');
        if (sel) {
          if (String(sel.value) !== String(want)) { sel.value = want; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          if (++asserts < 3) setTimeout(sync, 300); // re-assert in case the app resets it
          return;
        }
        if (Date.now() - t0 < 3000) setTimeout(sync, 120);
      })();
    }
    function openNotify(loadingEl, wantId) {
      var want = wantId || idInput.value; // native size handler already set idInput to the clicked variant
      if (clickApp()) { setModalSize(want); return; } // prewarmed → instant
      // fallback: button not injected yet → force it, then open
      if (loadingEl) loadingEl.classList.add('vd-notify-loading');
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      var done = false, stop = function () { if (loadingEl) loadingEl.classList.remove('vd-notify-loading'); };
      var mo = new MutationObserver(function () {
        if (done) return;
        if (clickApp()) { done = true; mo.disconnect(); stop(); setModalSize(want); }
      });
      mo.observe(form, { childList: true, subtree: true });
      setTimeout(function () { if (done) return; done = true; mo.disconnect(); stop(); if (clickApp()) setModalSize(want); }, 8000);
    }

    // Arrived from a PLP card sold-out size (or any ?variant + #vd-notify) → auto-open
    if (/vd-notify/.test(location.hash)) {
      var m = location.search.match(/variant=(\d+)/);
      var wantId = m ? m[1] : null;
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      var t0 = Date.now();
      var iv = setInterval(function () {
        if (appBtn() || Date.now() - t0 > 10000) { clearInterval(iv); openNotify(null, wantId); }
      }, 300);
    }

    // Pre-warm: the app SDK injects its (hidden) trigger only after it sees a
    // sold-out variant selected — which is slow on first paint. Nudge it on load
    // so the button is ready before the shopper clicks. idInput is restored to the
    // real selection as soon as the button appears (the app reads it on `change`).
    function prewarm() {
      if (appBtn()) return;                 // already present (whole-item sold out)
      var so = null;
      for (var i = 0; i < variants.length; i++) { if (!variants[i].available) { so = variants[i]; break; } }
      if (!so) return;                      // nothing sold out → no notify needed
      var real = idInput.value, tries = 0;
      var iv = setInterval(function () {
        // stop as soon as the button is ready, the user takes over, or the short warm-up window ends
        if (appBtn() || pdpUserPicked || ++tries > 4) {   // ~2.4s cap so we never clobber a real selection for long
          clearInterval(iv);
          if (!pdpUserPicked) idInput.value = real;         // restore only if the shopper hasn't picked a size
          return;
        }
        idInput.value = so.id;
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }, 600);
    }

    // (a) sold-out SIZE click → open notify (native handler already set input[name=id])
    sec.querySelectorAll('[data-pdp-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        pdpUserPicked = true; // stop prewarm from overwriting this selection
        setTimeout(function () {
          if (b.classList.contains('is-soldout')) openNotify(b);
        }, 0);
      });
    });

    // (b) whole-item / selected sold-out → make SOLD OUT add button a notify trigger
    if (addBtn) {
      // soldOut = truly disabled OR the label still says "Sold out". Checking the
      // label too means our own `disabled=false` (below) doesn't clear the flag.
      var syncAdd = function () {
        var soldOut = addBtn.disabled || /sold out|notify/i.test(addBtn.textContent || '');
        if (soldOut) {
          if (addBtn.disabled) addBtn.disabled = false;
          if (!addBtn.hasAttribute('data-vd-notify')) addBtn.setAttribute('data-vd-notify', '1');
        } else if (addBtn.hasAttribute('data-vd-notify')) {
          addBtn.removeAttribute('data-vd-notify');
        }
      };
      new MutationObserver(syncAdd).observe(addBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
      addBtn.addEventListener('click', function (e) {
        if (addBtn.hasAttribute('data-vd-notify')) {
          e.preventDefault(); e.stopImmediatePropagation();
          openNotify(addBtn);
        }
      }, true);
      // guard Enter-submit on a sold-out selection
      form.addEventListener('submit', function (e) {
        if (addBtn.hasAttribute('data-vd-notify')) { e.preventDefault(); e.stopImmediatePropagation(); openNotify(addBtn); }
      }, true);
      syncAdd();
    }

    // wait for the app SDK, then pre-warm once
    var w = 0, sdkWait = setInterval(function () {
      if (window.HengamRestock || ++w > 40) { clearInterval(sdkWait); prewarm(); }
    }, 250);
  }

  /* ---------- 2b. Landing pages (home): the app config ships LANDING_PAGES:NOT_DISPLAYED,
     so neither the loader nor the SDK touches index templates (verified in the loader source).
     Clone the COLLECTION_PAGE display config onto LANDING_PAGES and load the SDK ourselves —
     its injected triggers stay hidden (CSS above) and our NOTIFY ME proxies them, exactly
     like on collection pages. Scoped to templateName 'index'; never double-loads. ---------- */
  var landingWarming = false;
  function initLanding() {
    var cfg = window._ReStockConfig;
    if (!cfg || cfg.templateName !== 'index') return;
    if (window.HengamRestock || document.querySelector('script[src*="notify-me.io/sdk"]')) return;
    var ui = cfg.ui_style && cfg.ui_style.notify_me_styles;
    if (!ui) return;
    var coll = null, land = null, i;
    for (i = 0; i < ui.length; i++) { if (ui[i].page === 'COLLECTION_PAGE') coll = ui[i]; if (ui[i].page === 'LANDING_PAGES') land = ui[i]; }
    if (!coll) return;
    var copy = JSON.parse(JSON.stringify(coll)); copy.page = 'LANDING_PAGES';
    if (land) { for (var k in copy) land[k] = copy[k]; } else { ui.push(copy); }
    if (cfg.pre_order && cfg.pre_order.collection_page && cfg.pre_order.landing_page) {
      cfg.pre_order.landing_page.ui_styles = JSON.parse(JSON.stringify(cfg.pre_order.collection_page.ui_styles || {}));
    }
    landingWarming = true;
    var s = document.createElement('script'); s.src = 'https://cdn.notify-me.io/sdk.js'; s.defer = true;
    document.body.appendChild(s);
  }

  /* ---------- 2c. COMPONENT RULE (Hailin 2026-08-21): a sold-out preview card's NOTIFY ME
     opens the modal ON THE CURRENT PAGE — independent of template, load method, or product.
     Resolution order: this card's SDK trigger -> any same-product card's trigger (the SDK
     dedupes per product) -> feed the SDK a hidden decoy card for this product (its observer
     adopts any inserted card skeleton within ~1-2s) -> only then the PDP auto-open route. */
  var feedBox = null;
  function feedDecoy(handle) {
    if (!feedBox) {
      feedBox = document.createElement('div');
      feedBox.id = 'vd-notify-feed';
      feedBox.style.cssText = 'position:absolute;left:-9999px;top:0;width:300px;';
      document.body.appendChild(feedBox);
    }
    feedBox.innerHTML = '<div class="vd-card is-soldout" data-vd-card data-vd-handle="' + handle + '">' +
      '<a class="vd-card__imglink" href="/products/' + handle + '"></a>' +
      '<div class="vd-card__body"><div class="vd-card__swatches" data-vd-swatch-slot data-product-handle="' + handle + '"></div></div></div>';
    return feedBox;
  }
  function openNotify(card, handle, wantId) {
    var find = function () {
      return (card && card.querySelector('.restock-alerts-notify-button')) ||
        (handle ? document.querySelector('[data-vd-handle="' + handle + '"] .restock-alerts-notify-button') : null);
    };
    var goPdp = function () {
      var link = card && card.querySelector('a[href*="/products/"]');
      var base = link ? link.getAttribute('href').split('#')[0].split('?')[0] : (handle ? '/products/' + handle : null);
      if (!base) return;
      location.href = base + (wantId ? ('?variant=' + wantId) : '') + '#vd-notify';
    };
    var t = find();
    if (t) { t.click(); modalSizeGlobal(wantId); return; }
    if (handle) feedDecoy(handle);
    var t0 = Date.now();
    (function poll() {
      var tt = find();
      if (tt) { tt.click(); modalSizeGlobal(wantId); return; }
      if (Date.now() - t0 < 3500) { setTimeout(poll, 250); return; }
      goPdp();
    })();
  }
  function modalSizeGlobal(want) {
    if (!want) return;
    var t0 = Date.now(), asserts = 0;
    (function sync() {
      var sel = document.querySelector('.restock-alerts-modal-box .restock-alerts-variant-select');
      if (sel) {
        if (String(sel.value) !== String(want)) { sel.value = want; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        if (++asserts < 3) setTimeout(sync, 300);
        return;
      }
      if (Date.now() - t0 < 3000) setTimeout(sync, 120);
    })();
  }

  /* ---------- 3. PLP cards: sold-out size → PDP + auto-open notify ---------- */
  function initPLP() {
    // capture phase so this fires before vd-cards.js's quick-add click handler
    document.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('.vd-card__size.is-soldout, [data-vd-soldsize]');
      var notifyBtn = e.target.closest('.vd-card [data-vd-notify]');
      var soldTag = e.target.closest('.vd-card__soldtag[data-vd-soldcard]');
      var b = sizeBtn || soldTag || notifyBtn;
      if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var card = b.closest('.vd-card');
      var wantId = sizeBtn ? sizeBtn.getAttribute('data-vd-soldsize') : null;
      openNotify(card, card && card.getAttribute('data-vd-handle'), wantId);
    }, true);
  }

  function boot() { injectCSS(); initPDP(); initPLP(); setTimeout(initLanding, 800); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
